import script from "./trail-data.vue?vue&type=script&lang=ts&setup=true"
export * from "./trail-data.vue?vue&type=script&lang=ts&setup=true"

import "./trail-data.vue?vue&type=style&index=0&id=7ec17978&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec17978"]])

export default __exports__